import axios from 'axios';
const host = require('./host');

// ========== 鉴权配置（来源端密钥，须与后端配置一致） ==========
const authAppKey = 'sys_app_key' // 来源端 appKey
let authAppSecret = (typeof localStorage !== 'undefined' && localStorage.getItem('authAppSecret')) || '' // appSecret，从 base/getSysData 接口获取
let authTimeOffset = 0 // 服务器时间与本地时间偏移（毫秒），鉴权 time 以 base/getSysTime 返回的系统时间为准

// ========== SHA-256 / HMAC-SHA256 纯 JS 实现（零依赖，已对照 node:crypto 全量用例验证） ==========
const SHA_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]

// 字符串转 UTF-8 字节数组
function utf8Bytes (str) {
  const s = encodeURIComponent(String(str))
  const bytes = []
  for (let i = 0; i < s.length; i++) {
    if (s.charAt(i) === '%') {
      bytes.push(parseInt(s.substr(i + 1, 2), 16))
      i += 2
    } else {
      bytes.push(s.charCodeAt(i) & 0xff)
    }
  }
  return bytes
}

function rotr (x, n) {
  return ((x >>> n) | (x << (32 - n))) >>> 0
}

// SHA-256 压缩，返回 32 字节数组
function sha256Raw (bytes) {
  const H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19]
  const len = bytes.length
  const data = bytes.slice()
  data.push(0x80)
  while (data.length % 64 !== 56) data.push(0)
  const hi = Math.floor(len / 536870912) // 位长度高 32 位
  const lo = (len * 8) >>> 0 // 位长度低 32 位
  data.push((hi >>> 24) & 0xff, (hi >>> 16) & 0xff, (hi >>> 8) & 0xff, hi & 0xff)
  data.push((lo >>> 24) & 0xff, (lo >>> 16) & 0xff, (lo >>> 8) & 0xff, lo & 0xff)
  const w = new Array(64)
  for (let i = 0; i < data.length; i += 64) {
    for (let t = 0; t < 16; t++) {
      const j = i + t * 4
      w[t] = ((data[j] << 24) | (data[j + 1] << 16) | (data[j + 2] << 8) | data[j + 3]) >>> 0
    }
    for (let t = 16; t < 64; t++) {
      const x = w[t - 15]
      const y = w[t - 2]
      const s0 = rotr(x, 7) ^ rotr(x, 18) ^ (x >>> 3)
      const s1 = rotr(y, 17) ^ rotr(y, 19) ^ (y >>> 10)
      w[t] = (w[t - 16] + s0 + w[t - 7] + s1) >>> 0
    }
    let a = H[0]
    let b = H[1]
    let c = H[2]
    let d = H[3]
    let e = H[4]
    let f = H[5]
    let g = H[6]
    let h = H[7]
    for (let t = 0; t < 64; t++) {
      const S1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25)
      const ch = ((e & f) ^ (~e & g)) >>> 0
      const temp1 = (h + ch + S1 + SHA_K[t] + w[t]) >>> 0
      const S0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22)
      const maj = ((a & b) ^ (a & c) ^ (b & c)) >>> 0
      const temp2 = (S0 + maj) >>> 0
      h = g
      g = f
      f = e
      e = (d + temp1) >>> 0
      d = c
      c = b
      b = a
      a = (temp1 + temp2) >>> 0
    }
    H[0] = (H[0] + a) >>> 0
    H[1] = (H[1] + b) >>> 0
    H[2] = (H[2] + c) >>> 0
    H[3] = (H[3] + d) >>> 0
    H[4] = (H[4] + e) >>> 0
    H[5] = (H[5] + f) >>> 0
    H[6] = (H[6] + g) >>> 0
    H[7] = (H[7] + h) >>> 0
  }
  const out = []
  for (let i = 0; i < 8; i++) {
    out.push((H[i] >>> 24) & 0xff, (H[i] >>> 16) & 0xff, (H[i] >>> 8) & 0xff, H[i] & 0xff)
  }
  return out
}

function bytesToHex (bytes) {
  let hex = ''
  for (let i = 0; i < bytes.length; i++) hex += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16)
  return hex
}

// HMAC-SHA256，输出小写十六进制（与后端 Hutool DigestUtil/HMac 十六进制结果一致）
function hmacSha256Hex (message, secret) {
  let key = utf8Bytes(secret)
  if (key.length > 64) key = sha256Raw(key)
  const ipad = new Array(64).fill(0x36)
  const opad = new Array(64).fill(0x5c)
  for (let i = 0; i < key.length; i++) {
    ipad[i] ^= key[i]
    opad[i] ^= key[i]
  }
  const inner = sha256Raw(ipad.concat(utf8Bytes(message)))
  return bytesToHex(sha256Raw(opad.concat(inner)))
}

// ========== 鉴权业务逻辑（与售票端 tdllck 同一方案） ==========
// 获取随机数
function generateMixed (n) {
  const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  let res = ''
  for (let i = 0; i < n; i++) {
    res += chars[Math.floor(Math.random() * 62)]
  }
  return res
}

// 生成鉴权请求头：key = HmacSHA256(time + appkey + nonceStr + appSecret, appSecret) 十六进制小写，time 为服务器系统时间
export function getAuthHeaders () {
  const time = (new Date().getTime() + authTimeOffset).toString()
  const nonceStr = generateMixed(8)
  const sign = hmacSha256Hex(time + authAppKey + nonceStr + authAppSecret, authAppSecret)
  return { 'time': time, 'key': sign, 'appkey': authAppKey, 'nonceStr': nonceStr }
}

// 无需鉴权的接口（分销登录、获取appSecret、获取系统时间）
export function isNoAuthApi (reqUrl) {
  const url = reqUrl || ''
  return url.indexOf('auth/fxsLoginPost') > -1 || url.indexOf('base/getSysData') > -1 || url.indexOf('base/getSysTime') > -1
}

// 解析 getSysTime 返回的系统时间为毫秒时间戳（兼容13位毫秒/10位秒时间戳、日期字符串，以及 {status, data} 包装结构）
function parseServerTime (data) {
  let v = data
  if (v && typeof v === 'object') {
    v = v.data !== undefined ? v.data : (v.time !== undefined ? v.time : (v.sysTime !== undefined ? v.sysTime : v))
  }
  if (v === undefined || v === null || v === '') return 0
  if (typeof v === 'number') return v > 100000000000 ? v : v * 1000
  const s = String(v)
  if (/^\d+$/.test(s)) {
    const n = parseInt(s, 10)
    return n > 100000000000 ? n : n * 1000
  }
  const t = new Date(s.replace(/-/g, '/')).getTime()
  return isNaN(t) ? 0 : t
}

// 独立 axios 实例加载鉴权配置（避免与 request.js 循环依赖；该接口本身不鉴权）
const authAxios = axios.create({ timeout: 10000 })

// 从 base/getSysData 接口获取 appSecret，从 base/getSysTime 接口校准时间偏移，应用启动时调用
export function loadAuthConfig () {
  const base = host.host
  // 获取 appSecret
  authAxios.get(base + 'base/getSysData?code=' + authAppKey).then(res => {
    const data = res && res.data
    if (data && data.status == 1 && data.data) {
      // 兼容 data.data 为字符串或对象两种返回结构，若与实际返回结构不符请调整取值方式
      let secret = ''
      if (typeof data.data === 'string') {
        secret = data.data
      } else {
        secret = data.data.appSecret || data.data.secret || data.data[authAppKey] || data.data.value || ''
      }
      if (secret) {
        authAppSecret = secret
        if (typeof localStorage !== 'undefined') localStorage.setItem('authAppSecret', secret)
        console.log('获取appSecret成功')
      } else {
        console.log('获取appSecret失败，返回结构不匹配：', data)
      }
    } else {
      console.log('获取appSecret失败：', data)
    }
  }).catch(msg => {
    console.log('获取appSecret异常：', msg)
  })
  // 获取系统时间并计算时间偏移
  authAxios.get(base + 'base/getSysTime').then(res => {
    const t = parseServerTime(res && res.data)
    if (t > 0) {
      authTimeOffset = t - new Date().getTime()
      console.log('获取系统时间成功，时间偏移：' + authTimeOffset + 'ms')
    } else {
      console.log('获取系统时间失败，返回结构不匹配：', res && res.data)
    }
  }).catch(msg => {
    console.log('获取系统时间异常，鉴权时间将使用本地时间：', msg)
  })
}
